import { Component, OnInit, effect, inject, input } from '@angular/core';
import Highcharts from 'highcharts';
import { HighchartsService } from 'src/app/services/highcharts-service.service';
import { merge } from 'lodash';
import { DataSeries } from 'src/app/models/classes/data-series.class';

import { HighchartsChartComponent, ChartConstructorType } from 'highcharts-angular';
import { ChartType } from 'src/app/services/highcharts-service.service';

@Component({
  selector: 'app-gcm-chart',
  imports: [HighchartsChartComponent],
  templateUrl: './gcm-chart.component.html'
})
export class GcmChartComponent implements OnInit {
  private highChartsService = inject(HighchartsService);

  readonly chartType = input<'bar' | 'line' | 'map' | 'column' | 'funnel' | 'pie' | null>(null);
  readonly chartOptions = input<Highcharts.Options | null>(null);
  readonly chartData = input<DataSeries | DataSeries[] | null>(null);
  readonly chartStyle = input<Record<string, string>>({});
  readonly mapChartData = input<Record<string, unknown>[]>([]);
  readonly chartConstructor = input<ChartConstructorType>('chart');
  readonly noMerge = input<boolean>(false);
  readonly reflowEvent = input<unknown>(undefined);

  private readonly reflowOnEvent = effect(() => {
    this.reflowEvent();
    this.reflow();
  });

  mergedOptions: Highcharts.Options | null = null;
  chart: Highcharts.Chart | null = null;

  ngOnInit(): void {
    this.setChart = (newChart) => {
      this.chart = newChart;
    };
  }

  private readonly rebuildMergedOptions = effect(() => {
    const chartType = this.chartType();
    const chartData = this.chartData();
    const chartOptions = this.chartOptions();
    this.mapChartData();
    if (chartType === 'map' || this.noMerge()) {
      this.mergedOptions = chartOptions;
    } else {
      this.mergedOptions = merge(this.highChartsService.getDefaultHighchartsOptions(chartType as ChartType, chartData as DataSeries[]), chartOptions);
    }
    this.chart?.reflow();
  });

  reflow(): void {
    if (this.chart) {
      this.chart.reflow();
    }
  }

  setChart(chart: Highcharts.Chart): void {
    this.chart = chart;
  }
}